/**
 * Tracks which referral update IDs a user has already viewed (localStorage).
 * Used to highlight new updates the first time they appear on the detail page.
 */
const STORE_KEY = 'wcp.referral-updates-seen.v1';
function entryKey(userId, referralId) {
    return `${userId}:${referralId}`;
}
function readAll() {
    try {
        if (typeof window === 'undefined')
            return {};
        const raw = window.localStorage.getItem(STORE_KEY);
        if (!raw)
            return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    }
    catch {
        return {};
    }
}
function writeAll(map) {
    try {
        window.localStorage.setItem(STORE_KEY, JSON.stringify(map));
    }
    catch {
        // localStorage can be unavailable in restricted browser contexts.
    }
}
export function getSeenReferralUpdateIds(userId, referralId) {
    const list = readAll()[entryKey(userId, referralId)] ?? [];
    return new Set(list.filter((id) => typeof id === 'number' && Number.isFinite(id)));
}
/** Update IDs present in `updateIds` that the user has not seen yet. */
export function getUnseenReferralUpdateIds(userId, referralId, updateIds) {
    const seen = getSeenReferralUpdateIds(userId, referralId);
    return new Set(updateIds.filter((id) => !seen.has(id)));
}
/** Merge the given update IDs into the seen set for this user/referral. */
export function markReferralUpdatesSeen(userId, referralId, updateIds) {
    if (updateIds.length === 0)
        return;
    const key = entryKey(userId, referralId);
    const map = readAll();
    const next = new Set(map[key] ?? []);
    for (const id of updateIds) {
        if (typeof id === 'number' && Number.isFinite(id))
            next.add(id);
    }
    map[key] = [...next];
    writeAll(map);
}
